module.exports = __webpack_public_path__ + "img/pesaj-2017-thumbnail.aa755673.jpg";